module.exports = __webpack_public_path__ + "img/kartastavby.fead1038.svg";